import type { Agent } from "@/types/aiToolkit";
import type { AgentAnalysisResult } from "@/types/communications";
import { agentCanUseClickUpWrite } from "@/lib/clickupAgentPermissions";
import { agentCanUseTelegramWrite } from "@/lib/telegramAgentPermissions";

export type AgentActionType = "none" | "clickup" | "telegram_send";

export function resultsHaveDeliverables(results: AgentAnalysisResult[]): boolean {
  return results.some((r) => {
    if (r.error) return false;
    const parsed = r.parsed as Record<string, unknown> | undefined;
    const deliverables = parsed?.deliverables;
    return Array.isArray(deliverables) && deliverables.length > 0;
  });
}

export function resultsHaveTelegramReply(results: AgentAnalysisResult[]): boolean {
  return results.some((r) => {
    if (r.error) return false;
    const parsed = r.parsed as Record<string, unknown> | undefined;
    if (!parsed) return false;
    return (
      typeof parsed.reply === "string" ||
      typeof parsed.draftBody === "string" ||
      typeof parsed.body === "string"
    );
  });
}

export function getAgentActionType(
  agent: Agent | null | undefined,
  results: AgentAnalysisResult[]
): AgentActionType {
  if (agentCanUseTelegramWrite(agent) && resultsHaveTelegramReply(results)) {
    return "telegram_send";
  }
  if (agentCanUseClickUpWrite(agent) && resultsHaveDeliverables(results)) {
    return "clickup";
  }
  return "none";
}

export function shouldAutoPostClickUp(agent: Agent | null | undefined): boolean {
  return agent?.executionMode === "automatic";
}

export function shouldAutoPostTelegram(_agent: Agent | null | undefined): boolean {
  return false;
}
